export default "/images/dbf7bbee4f0cbf9db0532f12f444dde5.avif";